import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SettingsModel } from "../../Types/Settings.model";
import { RootState } from "../RootState";

const currentTheme = localStorage.getItem("theme");

const initialState: SettingsModel = {
  theme: !currentTheme || currentTheme === "light" ? "light" : "dark",
  profile: undefined,
  menuInfo: undefined,
  isTrashList: false,
  onError: undefined,
};

export const SettingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setTheme: (
      state: SettingsModel,
      action: PayloadAction<"light" | "dark">
    ) => {
      state.theme = action.payload;
    },
    setProfile: (state: SettingsModel, action: PayloadAction<any>) => {
      state.profile = action.payload;
    },
    setMenuInfo: (state: SettingsModel, action: PayloadAction<any>) => {
      state.menuInfo = action.payload;
    },
    setIsTrashList: (state: SettingsModel, action: PayloadAction<any>) => {
      state.isTrashList = action.payload;
    },
    setOnError: (state: SettingsModel, action: PayloadAction<any>) => {
      state.onError = action.payload;
    },
  },
});

export const { setTheme, setProfile, setMenuInfo, setIsTrashList, setOnError } =
  SettingsSlice.actions;

export default SettingsSlice.reducer;

export const themeModeSelector = (state: RootState) => state.settings.theme;
export const profileInfoSelector = (state: RootState) => state.settings.profile;
export const menuInfoSelector = (state: RootState) => state.settings.menuInfo;
export const isTrashListSelector = (state: RootState) =>
  state.settings.isTrashList;
export const onErrorSelector = (state: RootState) => state.settings.onError;
